import { ViewObjectSettings } from "../view-object-settings";

export class PanelSettings extends ViewObjectSettings {
  constructor(settings) {
    super(settings);
    this.items = [];
    if (settings.items !== undefined) {
      for (let itemIndex = 0; itemIndex < settings.items.length; itemIndex++) {
        this.items.push(settings.items[itemIndex].copy()); // type: ViewObjectSettings
      }
    }
  }

  copy() {
    return new PanelSettings(this);
  }
}
